import { FC } from 'react';

import DialogFormContent from 'components/DialogForm/DialogFormContent';
import useAddSpeakerProfile from 'modules/events/components/AddSpeakerProfile/AddSpeakerProfile.hook';
import { AddSpeakerProfileModalConfig } from 'modules/events/components/AddSpeakerProfile/AddSpeakerProfile.types';
import CardImage from 'modules/events/components/CardImage';
import Box from 'yoda-ui/Box';
import Divider from 'yoda-ui/Divider';
import TextYoda from 'yoda-ui/Form/TextYoda';
import { YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type SpeakerProfileProps = {
  speakerProfileConfig: AddSpeakerProfileModalConfig;
};

const SpeakerProfile: FC<SpeakerProfileProps> = ({
  speakerProfileConfig,
}) => {
  const { handleDropImage, addSpeakerProfileConfig } = useAddSpeakerProfile();

  return (
    <DialogFormContent>
      <Box>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Box width="48%">
            <TextYoda { ...speakerProfileConfig.title } />
          </Box>
          <Box width="48%">
            <TextYoda { ...speakerProfileConfig.firstName } />
          </Box>
        </Box>
        <Box paddingTop={ YodaSpacing.large }>
          <TextYoda { ...speakerProfileConfig.lastName } />
        </Box>
      </Box>
      <Box fontWeight={ YodaFontWeight.light } paddingTop={ YodaSpacing.large }>
        <CardImage
          handleFiles={ handleDropImage }
          { ...addSpeakerProfileConfig.image }
        />
      </Box>
      <Box paddingBottom={ YodaSpacing.large } paddingTop={ YodaSpacing.large }>
        <TextYoda { ...speakerProfileConfig.email } />
      </Box>
      <Divider />
      <Box paddingTop={ YodaSpacing.large }>
        <TextYoda { ...speakerProfileConfig.affiliation } />
      </Box>
      <Box paddingTop={ YodaSpacing.large }>
        <TextYoda { ...speakerProfileConfig.specialty } />
      </Box>
    </DialogFormContent>
  );
};

export default SpeakerProfile;
